import styled, { css } from "styled-components";
import { CaretTextProps } from "./CaretText";

export const StyledCaretTextContainer = styled("div")<CaretTextProps>`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  color: ${(props) => props.color || `inherit`};
  width: fit-content;
  padding: ${(props) => props.pd || ``};

  cursor: pointer;
  align-items: ${(props) => props.align || `baseline`};
  text-align: left;
  &.right {
    flex-direction: row;
  }
  &.left {
    flex-direction: row-reverse;
  }
  .caret {
    position: relative;
    /* slide via transform (compositor-only) so it stays smooth while a parent
       tile is scaling; animating left/right forces layout every frame */
    transition: transform 500ms ease-in-out;
    width: ${(props) => props.caretSize || props.fontSize || 1}rem;
    height: ${(props) => props.caretSize || props.fontSize || 1}rem;
    top: ${(props) =>
      props.caretSize
        ? `calc(${props.caretSize}rem / 2 - ${props.fontSize || 1}rem * 0.36)`
        : `calc(${props.fontSize || 1}rem * 0.2)`};
    &.right {
      margin-left: ${(props) =>
        props.caretSpacing || `calc(${props.fontSize || 1}rem * 0.2)`};
    }
    &.left {
      margin-right: ${(props) =>
        props.caretSpacing || `calc(${props.fontSize || 1}rem * 0.2)`};
      transform: scaleX(-1);
    }
  }
  .caret svg path {
    transition: stroke 500ms ease-in-out, fill 500ms ease-in-out;
  }
  div > div > p,
  div > .caret {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
    font-size: ${(props) => props.fontSize || 1}rem;
    line-height: ${(props) => props.fontSize || 1}rem !important;
    color: ${(props) => props.color || `inherit`};
  }

  p,
  .caret {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
    font-size: ${(props) => props.fontSize || 1}rem;
    line-height: ${(props) => props.fontSize || 1}rem !important;
    color: ${(props) => props.color || `inherit`};
    text-align: left;
  }

  &.hover:not(.disabled) {
    border-bottom-width: 2px;
    margin-bottom: 0px;
    .caret {
      &.right {
        transform: translateX(${(props) =>
          props.caretSize
            ? `calc(${props.caretSize}rem * 0.4)`
            : `calc(${props.fontSize || 1}rem * 0.6)`});
      }
      &.left {
        transform: scaleX(-1) translateX(${(props) =>
          props.caretSize
            ? `calc(${props.caretSize}rem * 0.4)`
            : `calc(${props.fontSize || 1}rem * 0.6)`});
      }
    }
    ${(props) =>
      props.hoverColor &&
      css`
        .caret svg path:not([fill="none"]) {
          fill: ${props.hoverColor};
        }
        .caret svg path[fill="none"] {
          stroke: ${props.hoverColor};
        }
      `}
  }

  &:active {
    p,
    .caret {
      color: grey;
    }
  }

  &.disabled {
    pointer-events: none;

    p,
    .caret {
      color: grey;
    }
  }
`;
